module.exports = __webpack_public_path__ + "media/application/images/icons/green-tick-e266ac4cbf92c40d70c4dd8cf781cf26.svg";